import { useFieldPrefix, useFieldValue } from "components/form/input/NestedField";
import TextInput from "components/form/input/TextInput";
import ApontamentoColetas from "entity/Indicador/components/apontamento/fields/ApontamentoColetas";
import ApontamentoImages from "entity/Indicador/components/apontamento/fields/ApontamentoImages";
import ApontamentoClienteParams, {
    ApontamentoParamItem,
} from "entity/Indicador/components/apontamento/fields/ApontamentoClienteParams";
import ApontamentoAmostraParams, {
    useTipoApontamento,
} from "entity/Indicador/components/apontamento/fields/ApontamentoAmostraParams";
import ApontamentoResultado from "entity/Indicador/components/apontamento/fields/ApontamentoResultado";
import ApontamentoObservacao from "entity/Indicador/components/apontamento/fields/ApontamentoObservacao";
import { useEffect, useState } from "react";
import BA from "..";
import FormRow from "components/form/FormRow";
import SelectInput from "components/form/input/SelectInput";
import { Field, useForm } from "react-final-form";
import BasicAccordion from "components/basic/BasicAccordion";
import FormContent from "components/form/FormContent";
import DateInput from "components/form/input/DateInput";
import { Autocomplete, TextField } from "@mui/material";
import EntitySearchInput from "components/form/EntitySearch/EntitySearchInput";
import Variedade from "entity/Variedade";

export default function BAEditFields({ visita, TipoClass }) {
    const [tipo] = useTipoApontamento();
    const params = visita.cliente.getParams(BA, tipo, TipoClass);

    const [apontamento] = useFieldValue();
    const form = useForm();

    const [talhoes, setTalhoes] = useState([]);
    const talhaoFieldName = useFieldPrefix("talhao");

    useEffect(() => {
        if (apontamento) {
            apontamento.conformidade = BA.calcConformidade(apontamento, params);
            form.change("conformidade", BA.calcConformidade(apontamento, params));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [apontamento, params]);

    useEffect(() => {
        if (visita.fazenda && visita.fazenda.data.talhoesFazenda) {
            setTalhoes(["", ...visita.fazenda.data.talhoesFazenda]);
        }
    }, [visita.fazenda]);

    return (
        <>
            <BasicAccordion title="Dados Básicos" defaultExpanded={true} fullWidth disableGutters>
                <FormContent>
                    <FormRow>
                        <DateInput showTime name="date" label="Data / Hora Coleta" disabled />
                    </FormRow>
                    <FormRow>
                        <Field
                            name={talhaoFieldName}
                            validate={(value) => (value && value.length > 0 ? undefined : "Campo obrigatório")}
                            render={({ input, meta }) => (
                                <div style={{ flex: 1 }}>
                                    <Autocomplete
                                        // multiple={input.value?.length ? true : false}
                                        multiple={!input.value || input.value.length ? true : false}
                                        value={input.value || []}
                                        onChange={(_, value) => input.onChange(value)}
                                        options={talhoes}
                                        getOptionLabel={(option) => option.nome || ""}
                                        isOptionEqualToValue={(option, value) => option.nome === value.nome}
                                        sx={{ flex: 1 }}
                                        renderInput={(params) => (
                                            <TextField
                                                label="Talhão"
                                                variant="standard"
                                                {...params}
                                                error={meta.error && meta.touched}
                                                helperText={meta.touched ? meta.error : ""}
                                            />
                                        )}
                                        renderOption={(props, option) => <li {...props}>{option.nome}</li>}
                                    />
                                </div>
                            )}
                        />
                    </FormRow>
                </FormContent>
            </BasicAccordion>

            <ApontamentoAmostraParams>
                <FormRow>
                    <SelectInput name="turno" label="Turno" options={["A", "B", "C"]} required />
                </FormRow>
                <FormRow>
                    <TextInput name="insumo" label="Variedade" />
                </FormRow>
                <FormRow>
                    <EntitySearchInput name="variedade" label="Variedade (Catálogo)" EntityClass={Variedade} />
                </FormRow>
            </ApontamentoAmostraParams>

            <ApontamentoClienteParams params={params}>
                {params ? (
                    <>
                        <ApontamentoParamItem label="Índice de Mariposas:">
                            {params.indiceMariposas}
                        </ApontamentoParamItem>
                        <ApontamentoParamItem label="Meta (%):">{params.meta}</ApontamentoParamItem>
                    </>
                ) : null}
            </ApontamentoClienteParams>

            <ApontamentoColetas visita={visita}>
                <TextInput name="armadilha" label="Armadilha" disabled />
                <TextInput type="number" name="qtdMariposas" label="Qtd. Mariposas" />
                <TextInput name="conforme" label="Índice" disabled />
            </ApontamentoColetas>

            <ApontamentoResultado conformidadeLabel="Resultado">
                <FormRow>
                    <TextInput name="indice" label="Índice" disabled />
                </FormRow>
            </ApontamentoResultado>
            <ApontamentoObservacao />
            <ApontamentoImages visita={visita} />
        </>
    );
}
